/**
 * SMS360 PMS API Client
 * Connects VD Storage Bells website to SMS360 backend for live data.
 */

// Same-origin, and NOT configurable. vercel.json rewrites /api/website/* to
// the mySMS360 API, so the browser never makes a cross-origin request — which
// matters because the API allows only *.mysms360.com plus an explicit origin
// list, and this domain is on neither, so an absolute URL would be blocked at
// the preflight.
//
// Both values are literals on purpose. They used to read env vars that are set
// in the Vercel dashboard and are invisible from the repo, which means nobody
// reading this file could tell what the deployed site actually called — and
// the in-repo defaults were a localhost URL and an empty facility id, so the
// checked-in answer was one that could never work. What ships is now what is
// written here.
const SMS360_API = '';
const FACILITY_ID = '6a0a96d21ccdf7b81fb02033';

const api = {
  /**
   * Get live unit availability grouped by type.
   * Returns: { facility_name, total_units, total_available, unit_types[] }
   */
  async getAvailability() {
    const res = await fetch(`${SMS360_API}/api/website/${FACILITY_ID}/units/available`);
    if (!res.ok) return null;
    return res.json();
  },

  /**
   * Get facility info (address, hours, features, etc.)
   */
  async getFacilityInfo() {
    const res = await fetch(`${SMS360_API}/api/website/${FACILITY_ID}/info`);
    if (!res.ok) return null;
    return res.json();
  },

  /**
   * Submit contact form → creates lead in SMS360.
   * Returns: { lead_id, status, message }
   */
  async submitContact({ name, email, phone, subject, message, website = '' }) {
    const res = await fetch(`${SMS360_API}/api/website/${FACILITY_ID}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // `website` is the form's honeypot — empty for a person.
      body: JSON.stringify({ name, email, phone, subject, message, website }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Failed to submit');
    }
    return res.json();
  },
};

export default api;
export { SMS360_API, FACILITY_ID };
